var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleUpperGiSurgery from '../../schemas/module-upper-gi-surgery.json';
var SchemaModuleUpperGiSurgery = (function (_super) {
    __extends(SchemaModuleUpperGiSurgery, _super);
    function SchemaModuleUpperGiSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleUpperGiSurgery);
        return _this;
    }
    return SchemaModuleUpperGiSurgery;
}(SchemaModuleUniversal));
export { SchemaModuleUpperGiSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-upper-gi-surgery.ts.pre-build-optimizer.js